import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`愛爾蘭商紅帽軟體股份有限公司（Red Hat） `}<a parentName="p" {...{
        "href": "https://www.redhat.com/zh-tw/home"
      }}>{`https://www.redhat.com/zh-tw/home`}</a>{` 是全球領先的開放原始碼軟體解決方案廠商，運用開發社群的力量提供可靠並且高效能的雲端、Linux、中介軟體、儲存和虛擬化技術，同時也提供備受業界肯定的技術支援、訓練和諮詢服務。 Red Hat 在全球的企業用戶、合作夥伴和開放原始碼社群中扮演橋樑的角色，協助創造相關的創新技術，將各種資源運用於成長的領域，並讓客戶為未來的 IT 架構座充份的準備。`}</p>
    <p>{`追蹤台灣紅帽獲得最新活動消息  `}<a parentName="p" {...{
        "href": "https://www.facebook.com/RedHatTaiwan/"
      }}>{`https://www.facebook.com/RedHatTaiwan/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      